module.exports = "a.disabled, a.active {\n  pointer-events: none;\n}\n"